/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  CheckLeadSimilarityRequest,
  CheckLeadSimilarityResult,
  ConvertLeadToClientRequest,
  CreateLeadRequest,
  GetLeadParams,
  LeadDto,
  ListLeadsParams,
  PaginatedLeadDto,
  UpdateLeadRequest,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getCheckLeadSimilarityUrl = () => {
  return `/api/v1/sales/leads/similarity`;
};

/**
 * Computes advisory same-country similarity against active and deleted Leads and Clients without creating or changing a resource.
 * @summary Check lead similarity
 */
export const checkLeadSimilarity = async (
  checkLeadSimilarityRequest: CheckLeadSimilarityRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CheckLeadSimilarityResult> => {
  return customFetch<CheckLeadSimilarityResult>(getCheckLeadSimilarityUrl(), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(checkLeadSimilarityRequest),
  });
};

export const getGetLeadUrl = (id: string, params?: GetLeadParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/sales/leads/${id}?${stringifiedParams}`
    : `/api/v1/sales/leads/${id}`;
};

/**
 * @summary Get lead
 */
export const getLead = async (
  id: string,
  params?: GetLeadParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<LeadDto> => {
  return customFetch<LeadDto>(getGetLeadUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getUpdateLeadUrl = (id: string) => {
  return `/api/v1/sales/leads/${id}`;
};

/**
 * @summary Update lead
 */
export const updateLead = async (
  id: string,
  updateLeadRequest: UpdateLeadRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getUpdateLeadUrl(id), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(updateLeadRequest),
  });
};

export const getDeleteLeadUrl = (id: string) => {
  return `/api/v1/sales/leads/${id}`;
};

/**
 * @summary Delete lead
 */
export const deleteLead = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteLeadUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getConvertLeadToClientUrl = (id: string) => {
  return `/api/v1/sales/leads/${id}/convert`;
};

/**
 * @summary Convert lead to client
 */
export const convertLeadToClient = async (
  id: string,
  convertLeadToClientRequest: ConvertLeadToClientRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getConvertLeadToClientUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(convertLeadToClientRequest),
  });
};

export const getListLeadsUrl = (params: ListLeadsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["countryCodes", "environments"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/sales/leads?${stringifiedParams}`
    : `/api/v1/sales/leads`;
};

/**
 * @summary List leads
 */
export const listLeads = async (
  params: ListLeadsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedLeadDto> => {
  return customFetch<PaginatedLeadDto>(getListLeadsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCreateLeadUrl = () => {
  return `/api/v1/sales/leads`;
};

/**
 * @summary Create lead
 */
export const createLead = async (
  createLeadRequest: CreateLeadRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getCreateLeadUrl(), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(createLeadRequest),
  });
};

export const getRestoreLeadUrl = (id: string) => {
  return `/api/v1/sales/leads/${id}/restore`;
};

/**
 * @summary Restore lead
 */
export const restoreLead = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRestoreLeadUrl(id), {
    ...options,
    method: "POST",
  });
};
